// extracted by mini-css-extract-plugin
module.exports = {"similar":"c6e8ba5398--similar--L7_Ac","similar--top3":"c6e8ba5398--similar--top3--2DuM_","similar--colorized":"c6e8ba5398--similar--colorized--3sTBR"};